// Gated-launch access code + pending-session helpers.
// The access code (from a ?code= invite link or typed on the register form) is
// persisted so it survives the OAuth round-trip, mirroring the ?ref handling.
const CODE_KEY = 'tagdada_access_code';
const PTOKEN_KEY = 'pending_token';

export function rememberCode(code) {
  try { if (code) localStorage.setItem(CODE_KEY, String(code).trim()); } catch { /* ignore */ }
}

export function getStoredCode() {
  try { return localStorage.getItem(CODE_KEY) || ''; } catch { return ''; }
}

export function clearCode() {
  try { localStorage.removeItem(CODE_KEY); } catch { /* ignore */ }
}

export function setPendingToken(token) {
  try { if (token) localStorage.setItem(PTOKEN_KEY, token); } catch { /* ignore */ }
}

export function getPendingToken() {
  try { return localStorage.getItem(PTOKEN_KEY) || ''; } catch { return ''; }
}

export function clearPendingToken() {
  try { localStorage.removeItem(PTOKEN_KEY); } catch { /* ignore */ }
}
